<template>
	<div class="add-wine-group-wrapper">
		<div class="wine-editor-wrapper">
			<detail-row-component
				title="와인"
				:inner-vertical="true"
				:disable-line="true"
			>
				<layout-auto-complete
					v-model="editable.wine_id"
					:http-options="httpOptions"
					api-url="/api/wines"
					track-name="wine_full_name"
					track-by="id"
					place-holder="와인을 검색하여 선택해주세요."
					width="220px"
				/>
			</detail-row-component>

			<detail-row-component title="짧은 와인 이름" :disable-line="true">
				<layout-input
					v-model="editable.short_wine_name"
					placeHolder="제목을 입력해주세요."
					width="220px"
				/>

				<layout-blank />

			</detail-row-component>

			<detail-row-component title="큐레이션 설명" :disable-line="true">
				<div class="curation-dsc-wrapper">
					<layout-input
						v-model="editable.curation_dsc"
						placeHolder="큐레이션 설명을 입력해주세요."
						width="220px"
					/>

					<layout-info title="* 12글자를 넘어가지 않게 작성해주세요." />
				</div>

				<layout-blank />
			</detail-row-component>

			<detail-row-component title="가격 색상" :disable-line="true">
				<layout-color-selector v-model="editable.price_color" />
			</detail-row-component>

			<detail-row-component title="가격 배경 색상" :disable-line="true">
				<layout-color-selector v-model="editable.price_bg_color" />
			</detail-row-component>
		</div>

		<div class="arrow-wrapper">
			<slot></slot>
		</div>
	</div>
</template>

<script>
import LayoutAutoComplete from "@/spa/components/LayoutAsyncAutoComplete";
import LayoutColorSelector from "@/spa/components/LayoutColorSelector";
import LayoutInput from "@/spa/components/LayoutInput";
import LayoutInfo from "@/spa/components/LayoutInfo";
import LayoutBlank from "@/spa/components/LayoutBlank";

import DetailRowComponent from "@/spa/components/detail-row/DetailRowComponent";

export default {
	name: "WineView",
	components: {
		LayoutAutoComplete,
		LayoutColorSelector,
		LayoutInput,
		LayoutInfo,
		LayoutBlank,

		DetailRowComponent
	},
	props: {
		value: Object
	},
	computed: {
		httpOptions() {
			return { headers: { Authorization: this.$store.getters.getToken } };
		}
	},
	watch: {
		"editable.wine_id": {
			deep: true,
			handler() {
				this.$emit("input", this.editable);
			}
		},

		"editable.short_wine_name": {
			deep: true,
			handler() {
				this.$emit("input", this.editable);
			}
		},

		"editable.curation_dsc": {
			deep: true,
			handler() {
				this.$emit("input", this.editable);
			}
		}
	},
	data() {
		return {
			editable: this.value
		};
	}
};
</script>

<style lang="scss" scoped>
.add-wine-group-wrapper {
	display: flex;
	justify-content: left;
	align-content: center;
	align-items: center;

	flex-direction: column;

	.wine-editor-wrapper {
		display: flex;
		justify-content: left;
		align-content: flex-start;
		align-items: flex-start;

		flex-direction: column;

		.detail-row-wrapper {
			display: flex;
			justify-content: left;
			align-content: center;
			align-items: center;

			flex-direction: row;

			.header-text {
				white-space: nowrap;
				height: 6px;
				width: 130px;
			}
		}
	}

	.arrow-wrapper {
		width: 100%;
		height: auto;

		margin-top: 10px;
		margin-bottom: 20px;

		display: flex;
		justify-content: center;
		align-items: center;
		align-content: center;

		flex-direction: row;

		.top-button {
			width: 80px;
			height: 30px;

			margin-right: 50px;
		}

		.down-button {
			width: 80px;
			height: 30px;
		}
	}
}

.curation-dsc-wrapper {
	display: flex;
	flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/curation/detail-row/curation-wine-list/WineView.vue